import { Component, Injector, Input, OnInit, forwardRef } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NgControl } from "@angular/forms";
import { Store, createSelector } from "@ngrx/store";
import { SharedModule } from "primeng/api";
import { FreyaCommonModule } from "src/app/freya-common/freya-common.module";
import { eventTypeInfoMapV2 } from "src/app/global.constants";
import { getEventInvoicedStatus, isFinalizedInvoice } from "src/app/invoices/invoices.utils";
import { ResponsiveHelperService } from "src/app/services/responsive-helper.service";

import { selectJob } from "../job-tool.reducer";
import { jobWorkordersFeature } from "../job-workorders/job-workorders.feature";
import { selectLockDate } from "../job-workorders/job-workorders.selectors";

@Component({
    selector: 'app-job-event-select',
    standalone: true,
    imports: [
      SharedModule,
      FreyaCommonModule,
    ],
    templateUrl: './event-select.component.html',
    styleUrl: './event-select.component.scss',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => JobEventSelectComponent),
            multi: true,
        }
    ]
})

export class JobEventSelectComponent implements ControlValueAccessor, OnInit {

    public ngControl: NgControl | null = null;

    constructor(
        private store: Store,
        public responsiveHelper: ResponsiveHelperService,
        private injector: Injector,
    ) {}

    ngOnInit(): void {
        this.ngControl = this.injector.get(NgControl, null, { self: true, optional: true });

        if (this.ngControl) {
            this.ngControl.valueAccessor = this;
        }
    }

    public value: string[] = [];

    @Input() public disabled = false;

    private onChange = (_: any) => {};

    private onTouched = () => {};

    writeValue(value: string[]): void {
        this.value = value ?? [];
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    setDisabledState?(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    handleSelect(ids: string[]) {
        this.value = ids;
        this.onChange(ids);
        this.onTouched();
    }

    eventSuggestions$ = this.store.select(createSelector(
        jobWorkordersFeature.selectWorkordersEditor,
        selectJob,
        selectLockDate,
        ({ workorders }, job, lockDate) => {
            const revenueGeneratingEvents = workorders?.filter(
                wo => wo.type !== eventTypeInfoMapV2.estimating.value &&
                    wo.type !== eventTypeInfoMapV2.virtualEstimate.value
            );

            return revenueGeneratingEvents.map((wo) => {

                const event = job?.events.find((e) => e.id === wo.eventId);

                return {
                    id: wo.eventId,
                    label: wo.title,
                    disabled: !!(event?.invoices?.some(isFinalizedInvoice) || (event?.end && lockDate > event?.end)),
                    invoiceStatus: getEventInvoicedStatus(event?.invoices || []),
                    event: {
                        id: wo.eventId,
                        title: wo.title,
                        status: event?.status || 'required',
                        start: event?.start,
                    }
                }
            });
        }
    ));
}
